function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 11-5-5v2a3 3 0 103 3V0z"
});

var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "tiktok_svg__bi tiktok_svg__bi-tiktok"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktdGlrdG9rIiB2aWV3Qm94PSIwIDAgMTYgMTYiPiA8cGF0aCBkPSJNOSAwaDEuOThjLjE0NC43MTUuNTQgMS42MTcgMS4yMzUgMi41MTJDMTIuODk1IDMuMzg5IDEzLjc5NyA0IDE1IDR2MmMtMS43NTMgMC0zLjA3LS44MTQtNC0xLjgyOVYxMWE1IDUgMCAxIDEtNS01djJhMyAzIDAgMSAwIDMgM1YwWiIvPiA8L3N2Zz4=";
export { SvgTiktok as ReactComponent };